// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_meK","footer":"styles_footer__3Blo2","passCodeTooltip":"styles_passCodeTooltip__3Y67o"};